import { render, staticRenderFns } from "./remision_crud.vue?vue&type=template&id=bc431db4"
import script from "./remision_crud.vue?vue&type=script&async=true&lang=js"
export * from "./remision_crud.vue?vue&type=script&async=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports